import {
	Button,
	CircularProgress,
	Dialog,
	DialogActions,
	DialogContent,
	DialogContentText,
	DialogTitle,
} from "@mui/material";
import { useMutation, useQueryClient } from "@tanstack/react-query";
import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import { ErrorModal } from "../../../../../components/modals/error-modal";
import { routeLogbookEntry } from "../../hooks/useEntries";
import { Entry } from "../../models/Entry";
import { deleteEntry } from "../../repository/LogbookRepository";

type Props = {
	entry: Entry | null;
	show: boolean;
	onHide: (onHide: boolean) => void;
};

export const RemoveEntryDialog = ({ entry, show, onHide }: Props) => {
	const navigate = useNavigate();

	const [isSubmitLoading, setIsSubmitLoading] = useState(false);
	const [successMessage, setSuccessMessage] = useState("");
	const [error, setError] = useState("");

	const handleCancel = () => {
		setIsSubmitLoading(false);
		onHide(false);
	};

	const queryClient = useQueryClient();
	const removeEntry = useMutation(deleteEntry, {
		onSuccess: async () => {
			await queryClient.invalidateQueries({ queryKey: ["entries"] });
			navigate(`${routeLogbookEntry}`, { replace: true });
			setSuccessMessage("The entry was deleted succesfully");
			onHide(true);
		},
		onError: (error: Error) => {
			setError(error.message);
		},
		onSettled: () => setIsSubmitLoading(false),
	});

	return (
		<>
			<Dialog
				fullWidth={true}
				maxWidth={"md"}
				open={show}
				onClose={() => handleCancel()}
				disableEnforceFocus
				sx={{
					"& .input-group-text": {
						display: "none",
					},
					"& .MuiDialogContent-dividers": {
						padding: 0,
					},
				}}
			>
				<DialogTitle id="responsive-dialog-title" style={{ paddingBottom: 0 }}>
					{"WARNING"}
				</DialogTitle>
				<DialogContent>
					<DialogContentText style={{ padding: 0, margin: 0 }}>
						Be careful, you are about to delete: <b>{entry?.Title}</b>. Once
						deleted you will not be able to recover this Entry. Are you sure you
						want to delete it?
					</DialogContentText>
				</DialogContent>
				<DialogActions style={{ padding: "0 24px 16px" }}>
					<Button onClick={() => onHide(false)} autoFocus color="inherit">
						CANCEL
					</Button>
					<Button
						autoFocus
						color="secondary"
						startIcon={isSubmitLoading && <CircularProgress size="1rem" />}
						onClick={() => removeEntry.mutate(entry?.EntryId ?? 0)}
					>
						Delete
					</Button>
				</DialogActions>
			</Dialog>
			{/* <NotificationSnackBar
        message={successMessage}
        onHide={() => setSuccessMessage("")}
      /> */}
			<ErrorModal error={error} onHide={() => setError("")} />
		</>
	);
};
